module.exports = __webpack_public_path__ + "img/dragan_babic.18f8274a.jpg";